import { Address, WorkType } from 'constants/index';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import { SvgUse } from '@dnse/ui';

import { IconStrokeColor } from '../../constants/IconStrokeColor';
import { UploadYourCV } from './UploadYourCV';


interface Props {
  handleClearFilter: () => void;
  departments: string[];
}

export const JobsFilterMobile: React.FC<Props> = ({
  handleClearFilter,
  departments
}) => {
  const [isOpenFilter, setIsOpenFilter] = useState({
    location: false,
    workType: false,
    department: false
  });
  const router = useRouter();
  const [addressFilter, setAddressFilter] = useState([]);
  const [workTypeFilter, setWorkTypeFilter] = useState([]);
  const [departmentFilter, setDepartmentFilter] = useState([]);
  const isDisableClearFilterButton = router.pathname === router.asPath;

  useEffect(() => {
    setAddressFilter(
      router.query.address
        ? decodeURIComponent(router.query.address.toString()).split(',')
        : []
    );
    setDepartmentFilter(
      router.query.department
        ? decodeURIComponent(router.query.department.toString()).split(',')
        : []
    );
    setWorkTypeFilter(
      router.query.workType
        ? decodeURIComponent(router.query.workType.toString()).split(',')
        : []
    );
  }, [router.query]);

  const isAddressFilterActive = addressFilter.length > 0;
  const isWorkTypeFilterActive = workTypeFilter.length > 0;
  const isDepartmentFilterActive = departmentFilter.length > 0;

  const handleUpdateAddressFilter = (address: string) => {
    const index = addressFilter.indexOf(address);
    const addressFilterClone = [...addressFilter];
    if (index === -1) {
      addressFilterClone.push(address);
    } else {
      addressFilterClone.splice(index, 1);
    }
    setAddressFilter(addressFilterClone);
    if (addressFilterClone.length > 0) {
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: {
          ...router.query,
          address: encodeURIComponent(addressFilterClone.join(','))
        }
      });
    } else {
      const { address, ...rest } = router.query;
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: rest
      });
    }
  };

  const handleUpdateDepartmentFilter = (department: string) => {
    const index = departmentFilter.indexOf(department);
    const departmentFilterClone = [...departmentFilter];
    if (index === -1) {
      departmentFilterClone.push(department);
    } else {
      departmentFilterClone.splice(index, 1);
    }
    setDepartmentFilter(departmentFilterClone);
    if (departmentFilterClone.length > 0) {
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: {
          ...router.query,
          department: encodeURIComponent(departmentFilterClone.join(','))
        }
      });
    } else {
      const { department, ...rest } = router.query;
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: rest
      });
    }
  };

  const handleUpdateWorkTypeFilter = (workType: string) => {
    const index = workTypeFilter.indexOf(workType);
    const workTypeFilterClone = [...workTypeFilter];
    if (index === -1) {
      workTypeFilterClone.push(workType);
    } else {
      workTypeFilterClone.splice(index, 1);
    }
    setWorkTypeFilter(workTypeFilterClone);
    if (workTypeFilterClone.length > 0) {
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: {
          ...router.query,
          workType: encodeURIComponent(workTypeFilterClone.join(','))
        }
      });
    } else {
      const { workType, ...rest } = router.query;
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: rest
      });
    }
  };

  return (
    <>
      <div className="flex justify-between text-sm font-medium px-4 pt-3">
        <span>Bộ lọc</span>
        <div className="flex gap-x-3">
          <UploadYourCV />
          <button
            className={`underline text-brand-300 ${
              isDisableClearFilterButton ? 'opacity-50' : ''
            }`}
            onClick={handleClearFilter}
            disabled={isDisableClearFilterButton}
          >
            Xoá bộ lọc
          </button>
        </div>
      </div>
      <div className="flex px-4 py-3 overflow-x-scroll w-screen mb-1 no-scrollbar">
        <div className="flex items-center gap-x-3 text-sm font-normal text-gray-800 ">
          <button
            style={{
              boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10)'
            }}
            className={`h-full flex items-center gap-x-2 rounded-[100px] px-4 py-2 w-[138px] ${
              isAddressFilterActive
                ? 'text-brand-300 border border-solid border-brand-300 bg-brand-300/[.1]'
                : 'border-transparent border'
            }`}
            onClick={() =>
              setIsOpenFilter({
                workType: false,
                location: true,
                department: false
              })
            }
          >
            <SvgUse id="location-outline" width={16} height={16} />
            Địa điểm
            <SvgUse id="cheveron-down-outline" width={16} height={16} />
          </button>
          <button
            onClick={() =>
              setIsOpenFilter({
                workType: true,
                location: false,
                department: false
              })
            }
            style={{ boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10)' }}
            className={`h-full flex items-center gap-x-2 rounded-[100px] px-4 py-2 w-[207px] ${
              isWorkTypeFilterActive
                ? 'text-brand-300 border border-solid border-brand-300 bg-brand-300/[.1]'
                : 'border-transparent border'
            }`}
          >
            <SvgUse id="outline-clock" width={16} height={16} />
            Hình thức làm việc
            <SvgUse id="cheveron-down-outline" width={16} height={16} />
          </button>
          <button
            onClick={() =>
              setIsOpenFilter({
                workType: false,
                location: false,
                department: true
              })
            }
            style={{ boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10)' }}
            className={`h-full flex items-center gap-x-2 rounded-[100px] px-4 py-2 w-[150px] ${
              isDepartmentFilterActive
                ? 'text-brand-300 border border-solid border-brand-300 bg-brand-300/[.1]'
                : 'border-transparent border'
            }`}
          >
            <SvgUse
              id="department-outline"
              width={16}
              height={16}
              stroke={
                isAddressFilterActive
                  ? IconStrokeColor.Red
                  : IconStrokeColor.Gray
              }
            />
            Phòng ban
            <SvgUse id="cheveron-down-outline" width={16} height={16} />
          </button>
        </div>
        {isOpenFilter.location && (
          <div
            className="fixed z-20 bottom-0 left-0 w-full shadow-[0_-5px_15px_rgba(0,0,0,0.3)] "
            style={{
              borderRadius: '4px 4px 0 0',
              background: 'var(--light-bg-60, rgba(255, 255, 255, 0.60))',
              backdropFilter: 'blur(20px)'
            }}
          >
            <div className="flex items-center justify-between py-3 px-4">
              <div className="flex items-center gap-x-1 text-base font-medium">
                <SvgUse id="location-outline-gray" width={16} height={16} />
                Địa điểm
              </div>
              <SvgUse
                id="close-outline"
                width={20}
                height={20}
                onClick={() =>
                  setIsOpenFilter(prev => ({ ...prev, location: false }))
                }
              />
            </div>
            <div className="bg-gray-800 h-[1px] opacity-25" />
            <div className="flex flex-wrap gap-x-2 items-center py-[8px] px-4 pb-[38px]">
              {Address.map((address, index) => (
                <button
                  key={index}
                  onClick={() => handleUpdateAddressFilter(address)}
                  className={`flex items-center rounded-[100px] px-4 py-2 text-sm h-[34px] font-normal shadow ${
                    addressFilter.includes(address)
                      ? 'bg-brand-300 text-white'
                      : 'text-gray-800 bg-gray-1000'
                  }`}
                >
                  {address}
                </button>
              ))}
            </div>
          </div>
        )}

        {isOpenFilter.workType && (
          <div
            className="fixed z-20 bottom-0 left-0 w-full shadow-[0_-5px_15px_rgba(0,0,0,0.3)] "
            style={{
              borderRadius: '4px 4px 0 0',
              background: 'var(--light-bg-60, rgba(255, 255, 255, 0.60))',
              backdropFilter: 'blur(20px)'
            }}
          >
            <div className="flex items-center justify-between py-3 px-4">
              <div className="flex items-center gap-x-1 text-base font-medium">
                <SvgUse
                  id="outline-clock"
                  width={16}
                  height={16}
                  className="text-gray-800"
                />
                Hình thức làm việc
              </div>
              <SvgUse
                id="close-outline"
                width={20}
                height={20}
                onClick={() =>
                  setIsOpenFilter(prev => ({ ...prev, workType: false }))
                }
              />
            </div>
            <div className="bg-gray-800 h-[1px] opacity-25" />
            <div className="flex flex-wrap gap-2 items-center py-[8px] px-4 pb-[38px]">
              {WorkType.map((worktype, index) => (
                <button
                  key={index}
                  onClick={() => handleUpdateWorkTypeFilter(worktype)}
                  className={`flex items-center rounded-[100px] px-4 py-2 text-sm h-[34px] font-normal shadow ${
                    workTypeFilter.includes(worktype)
                      ? 'bg-brand-300 text-white'
                      : 'text-gray-800 bg-gray-1000'
                  }`}
                >
                  {worktype}
                </button>
              ))}
            </div>
          </div>
        )}

        {isOpenFilter.department && (
          <div
            className="fixed z-20 bottom-0 left-0 w-full shadow-[0_-5px_15px_rgba(0,0,0,0.3)] "
            style={{
              borderRadius: '4px 4px 0 0',
              background: 'white',
              backdropFilter: 'blur(50px)'
            }}
          >
            <div className="flex items-center justify-between py-3 px-4">
              <div className="flex items-center gap-x-1 text-base font-medium">
                <SvgUse
                  id="department-outline"
                  width={16}
                  height={16}
                  className="text-gray-800"
                />
                Phòng ban
              </div>
              <SvgUse
                id="close-outline"
                width={20}
                height={20}
                onClick={() =>
                  setIsOpenFilter(prev => ({ ...prev, department: false }))
                }
              />
            </div>
            <div className="bg-gray-800 h-[1px] opacity-25" />
            <div className="flex flex-wrap gap-2 items-center py-[8px] px-4 pb-[38px]">
              {departments.map((department, index) => (
                <button
                  key={index}
                  onClick={() => handleUpdateDepartmentFilter(department)}
                  className={`flex items-center rounded-[100px] px-4 py-2 text-sm h-[34px] font-normal shadow ${
                    departmentFilter.includes(department)
                      ? 'bg-brand-300 text-white'
                      : 'text-gray-800 bg-gray-1000'
                  }`}
                >
                  {department}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
